import styled from 'styled-components';

// 모달
export const ModalBg = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .post-modal-box {
        width: 400px !important;
        height: 600px !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`
export const ModalType1 = styled.div`
    width: 100%;
    max-width: 320px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 6px;
    padding: 32px 20px 20px 20px;

    p {
        font-size: 14px;
        color: #000;
        line-height: 140%;
        white-space: pre-wrap;
    }

    .btn-box {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-top: 48px;
    }
`
export const ModalType2 = styled.div`
    width: 100%;
    max-width: 500px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 6px;
    padding: 32px 20px 20px 20px;

    h2 {
        font-size: 18px;
        font-weight: 700;
        color: #111;
    }

    .input-area {
        display: flex;
        flex-direction: column;
        margin-top: 24px;

        > li {
            display: flex;
            flex-direction: column;
            gap: 20px;

            > ul {
                width: 100%;
                display: flex;
                gap: 12px;

                > li {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    h3 {
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;

                        > span {
                            display: inline-block;
                            color: #FF5151;
                            margin-left: 2px;
                        }
                    }

                    .input-btn-box {
                        display: flex;
                        gap: 8px;
                    }
                }
            }
        }
    }

    .btn-box {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-top: 48px;
    }
`
export const ModalType2SizeDown = styled(ModalType2)`
    max-width: 360px;
`

// 검색 옵션 박스
export const SearchOptionBox = styled.div`
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;

    .search-area {
        max-width: 980px;
        width: 100%;

        > ul {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        column-gap: 40px;
        row-gap: 16px;

            > li {
                display: flex;
                align-items: center;
                width: calc(33.3333% - 26.6666px);

                h3 {
                    min-width: 90px;
                    font-size: 15px;
                    color: #333;
                    font-weight: 500;
                }

                .input-area {
                    width: calc(100% - 90px);
                    display: flex;
                    gap: 8px;
                }
            }
        }
    }

    .btn-box {
        min-width: 127px;
        gap: 6px;
    }

    @media (max-width: 1420px) {
        .search-area {
            max-width: 700px;

            > ul {
                column-gap: 28px;

                > li {
                    width: calc(50% - 14px);
                }
            }
        }
    }

    @media (max-width: 1120px) {
        .search-area {
            max-width: 360px;

            > ul {
                > li {
                    width: 100%;
                }
            }
        }
    }
`

// 테이블 옵션 박스
export const TableOptionBox = styled.div`
    margin-top: 28px;
    display: flex;
    align-items: end;
    justify-content: space-between;

    .all-text-box {
        font-size: 14px;
        color: #111;

        span {
            display: inline-block;
            font-weight: 700;
            color: ${props => props.theme.mainColor1};
        }
    }

    .btn-option-box {
        display: flex;
        gap: 8px;
    }
`

// 테이블 타입1
export const TableType1 = styled.div`
    overflow: auto;
    margin-top: 12px;
    border-radius: 6px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);

    table {
        tr th {
            font-size: 13px;
            font-weight: inherit;
            color: #5C5C5C;
            line-height: 14px;
            background: #fff;
            box-sizing: border-box;
            padding: 15px 7px 8px 7px;
            white-space: nowrap;
            border: none;
            border-bottom: 1px solid #54585A;
            text-align: center;
            font-weight: 700;
            vertical-align: top;
        }
        tr td {
            font-size: 13px;
            font-weight: 400;
            color: #111;
            background: #fff;
            box-sizing: border-box;
            padding: 8px 7px;
            white-space: nowrap;
            border: none;
            border-bottom: 1px solid #DBDBDB;
            text-align: center;
            line-height: 150%;
            vertical-align: middle;
            &.expiration {
                color: #DD6868;
            }
            &.normal {
                color: #24BB33;
            }

            .modify-btn {
                display: inline-block;
                color: #437BE6;
                text-decoration: underline;
            }

            .pdf-btn {
                width: 24px;
                display: inline-block;
            }
        }
    }
`

// 페이지네이션
export const Pagenation = styled.div `
    margin-top: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    
    > button {
        width: 20px;
        &:disabled {
            opacity: 0;
            cursor: inherit;
        }
    }

    > ul {
        display: flex;
        gap: 4px;

        > li {
            width: 30px;
            height: 30px;
            border-radius: 2px;
            border: 1px solid #D9D9D9;
            background: #fff;
            color: #949494;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active {
                background: ${props => props.theme.mainColor1};
                color: #fff;
            }
        }
    }
`

// 버튼1 타입
export const Btn1Type = styled.button`
    width: 100%;
    height: 56px;
    box-sizing: border-box;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
`
export const Btn1Type1 = styled(Btn1Type)`
    color: #fff;
    background-color: ${props => props.theme.mainColor1};
`
export const Btn1Type2 = styled(Btn1Type)`
    color: #555;
    background-color: #fff;
    border: 1px solid #555;

`
export const Btn1Type3 = styled(Btn1Type)`
    color: #fff;
    background-color: ${props => props.theme.mainColor2};
`

// 버튼2 타입
export const Btn2Type = styled.button`
    width: 68px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
`
export const Btn2Type1 = styled(Btn2Type)`
    color: #fff;
    background-color: ${props => props.theme.mainColor1};
`
export const Btn2Type2 = styled(Btn2Type)`
    color: #999999;
    background-color: #F2F4F6;
`
export const Btn2Type3 = styled(Btn2Type)`
    min-width: 68px;
    color: #333;
    background-color: #dbdbdb;
`

// 버튼3 타입
export const Btn3Type = styled.button`
    box-sizing: border-box;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
`
export const Btn3Type1 = styled(Btn3Type)`
    color: #fff;
    background-color: ${props => props.theme.mainColor1};
`
export const Btn3Type2 = styled(Btn3Type)`
    color: #333;
    background-color: #dbdbdb;
`
export const Btn3Type3 = styled(Btn3Type)`
    color: #fff;
    background-color: #FF6F32;
`
export const Btn3Type4 = styled(Btn3Type)`
    color: #fff;
    background-color: #0F783F;
`

// 버튼4 타입
export const Btn4Type = styled.button`
    max-width: 68px;
    min-width: 68px;
    max-width: 68px;
    min-width: 68px;
    border-radius: 4px;
    font-size: 14px;
`
export const Btn4Type1 = styled(Btn4Type)`
    color: #fff;
    background-color: #FF6F32;
    &:disabled {
        cursor: inherit;
        background: #999;
    }
`

// 인풋 타입1
export const TextInputType1 = styled.input`
    display: block;
    width: 100%;
    height: 36px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.borderColor};
    box-sizing: border-box;
    padding: 0 12px;
    font-size: 14px;
    color: ${props => props.theme.inputColor};
    &::placeholder {
        color: ${props => props.theme.inputPlaceholderColor};
    }
    &:disabled {
        color: #555;
        background: #eee;
    }
    &[type="date"] {
        color: ${props => props.theme.inputPlaceholderColor};
    }
    &[type="date"].selected {
        color: ${props => props.theme.inputColor};
    }
`

// 셀렉트 타입1
export const SelectType1 = styled.div`
    width: 100%;
    position: relative;

    > select {
        display: block;
        width: 100%;
        height: 36px;
        border-radius: 4px;
        border: 1px solid ${props => props.theme.borderColor};
        box-sizing: border-box;
        padding: 0 30px 0 12px;
        font-size: 14px;
        color: ${props => props.theme.inputPlaceholderColor};
        &.selected {
            color: ${props => props.theme.inputColor};
        }

        option {
            color: ${props => props.theme.inputColor};
        }
    }

    > .img-box {
        position: absolute;
        width: 16px;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
    }
`

// 텍스트 영역 타입1
export const TextAreaType1 = styled.textarea`
    display: block;
    width: 100%;
    height: 90px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.borderColor};
    box-sizing: border-box;
    padding: 12px;
    font-size: 12px;
    color: ${props => props.theme.inputColor};
    &::placeholder {
        color: ${props => props.theme.inputPlaceholderColor};
    }
`

// 체크 박스 타입1
export const CheckBoxType1 = styled.div `
    width: 16px;
    height: 16px;
    margin: 0 auto;

    input {
        display:none
    }

    label {
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: block;
        background: url(./img/ico_check_1.svg);
    }

    input:checked + label {
        background: url(./img/ico_check_1_active.svg);
    }
`

const CS = {
    ModalBg,
    ModalType1,
    ModalType2,
    ModalType2SizeDown,

    SearchOptionBox,

    TableOptionBox,

    TableType1,

    Pagenation,

    Btn1Type1,
    Btn1Type2,
    Btn1Type3,
    Btn2Type1,
    Btn2Type2,
    Btn2Type3,
    Btn3Type1,
    Btn3Type2,
    Btn3Type3,
    Btn3Type4,
    Btn4Type1,
    TextInputType1,
    SelectType1,
    TextAreaType1,
    CheckBoxType1
};

export default CS;